import { render } from "./InitialRequestTab.vue?vue&type=template&id=891a145e&scoped=true"
import script from "./InitialRequestTab.vue?vue&type=script&lang=js"
export * from "./InitialRequestTab.vue?vue&type=script&lang=js"

import "./InitialRequestTab.vue?vue&type=style&index=0&id=891a145e&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-891a145e"]])

export default __exports__